// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1Z7KH","content":"styles_content__3z123","intro":"styles_intro__2gokp"};